var map = {
	"./icon-admin.svg": "6sdf",
	"./icon-bianji.svg": "LlQS",
	"./icon-config.svg": "DsnQ",
	"./icon-dangdifill.svg": "2Cd2",
	"./icon-daohang.svg": "LqJT",
	"./icon-duanxin.svg": "YXyf",
	"./icon-editor.svg": "0TsT",
	"./icon-geren.svg": "P3OB",
	"./icon-jiesuo.svg": "sOwB",
	"./icon-job.svg": "cFoh",
	"./icon-log.svg": "yCXC",
	"./icon-menu.svg": "Og7c",
	"./icon-mudedi.svg": "hhw/",
	"./icon-oss.svg": "EkDd",
	"./icon-pinglun.svg": "+aBt",
	"./icon-role.svg": "kMeK",
	"./icon-shanchu.svg": "dGgB",
	"./icon-shezhi.svg": "UQPm",
	"./icon-shoucang.svg": "ELti",
	"./icon-shoucangfill.svg": "/90L",
	"./icon-shouye.svg": "GIrI",
	"./icon-sousuo.svg": "MSZQ",
	"./icon-sql.svg": "Vzxs",
	"./icon-suoding.svg": "HRKG",
	"./icon-system.svg": "9Rh0",
	"./icon-tixing.svg": "DeBA",
	"./icon-tubiao.svg": "pc3V",
	"./icon-xiangqu.svg": "y3Q9",
	"./icon-xiangqufill.svg": "t+PV",
	"./icon-zhedie.svg": "IeK1",
	"./icon-zonghe.svg": "BClt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eZ11";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg \.svg$
// module id = eZ11
// module chunks = 48